import { CheckboxInput, DropdownInput, RadioInput } from './ChoiceInputs';
import { DateInput, FileInput } from './DateFileInputs';
import {
  MatrixInput,
  RatingInput,
  RepeaterInput,
  TableInput,
} from './GridInputs';
import { DescriptionBlock, ImageBlock, VideoBlock } from './LayoutBlocks';
import { AddressInput, NameInput, PhoneField } from './PersonInputs';
import {
  EmailInput,
  LongAnswerInput,
  NumberInput,
  ShortAnswerInput,
} from './TextInputs';

// Answer type → its control. Every control takes
// { field, value, onChange(value), inputId, labelId, describedBy, invalid }.
export const INPUTS = {
  short_answer: ShortAnswerInput,
  long_answer: LongAnswerInput,
  name: NameInput,
  address: AddressInput,
  email: EmailInput,
  phone: PhoneField,
  number: NumberInput,
  dropdown: DropdownInput,
  radio: RadioInput,
  checkbox: CheckboxInput,
  datetime: DateInput,
  file_upload: FileInput,
  table: TableInput,
  repeater: RepeaterInput,
  matrix: MatrixInput,
  rating: RatingInput,
};

// Types whose visible label is a <label for> one control; the rest label a
// group of controls.
export const SINGLE_CONTROL_TYPES = [
  'short_answer',
  'long_answer',
  'email',
  'phone',
  'number',
  'dropdown',
];

// Layout type → its block ({ field, assetUrls }). Sections are drawn as
// group headers by PreviewForm, not here.
export const BLOCKS = {
  description: DescriptionBlock,
  image: ImageBlock,
  video: VideoBlock,
};

export { SectionHeader } from './LayoutBlocks';
